import { secondsPer } from '@art-suite/art-core-ts';
import { errorIsClientFailure, errorIsClientFailureNotAuthorized } from '@kaiizen/zod-less-api';

export const SYNC_TIMEOUT_SECONDS = 5 * secondsPer.minute;

export const reduceSyncCounts = (counts: number[]): number => counts.reduce((acc: number, count: number) => acc + count, 0);

export const reducePromisedCounts = (counts: Promise<number>[]): Promise<number> => Promise.all(counts).then(reduceSyncCounts);

export class HardFailureError extends Error {
  readonly isHardFailure = true as const;
  constructor(message: string) {
    super(message);
    this.name = 'HardFailureError';
  }
}

export const isHardFailure = (error: any): boolean =>
  error instanceof HardFailureError
  || error?.isHardFailure === true
  || (errorIsClientFailure(error) && !errorIsClientFailureNotAuthorized(error));

export const isSoftFailure = (error: any): boolean => !isHardFailure(error);

export const getAge = (date: Date, now: number = Date.now()) => now - date.getTime();
